/**
 * Orka V3 — Project / Workstream identity map (PRD §3.1).
 *
 * Project colour is a WORKSTREAM identity signal. Independent of priority.
 * Source of truth — remove duplicate project colour maps.
 */
export const PROJECT_META = Object.freeze({
  billing: {
    key: 'billing',
    label: 'Billing / SaaS',
    short: 'BILL',
    primary: '#2563eb',
    secondary: '#1d4ed8',
    tertiary: '#0ea5e9',
    text: '#eff6ff',
    categories: ['Stripe', 'Entitlements', 'Upgrade UX'],
  },
  identity: {
    key: 'identity',
    label: 'Identity',
    short: 'ID',
    primary: '#7c3aed',
    secondary: '#6d28d9',
    tertiary: '#a855f7',
    text: '#f5f3ff',
    categories: ['SSO', 'Permissions', 'Reset Flow'],
  },
  growth: {
    key: 'growth',
    label: 'Growth',
    short: 'GROW',
    primary: '#059669',
    secondary: '#047857',
    tertiary: '#14b8a6',
    text: '#ecfdf5',
    categories: ['Trials', 'Activation', 'Upgrade'],
  },
  ops: {
    key: 'ops',
    label: 'Operations',
    short: 'OPS',
    primary: '#d97706',
    secondary: '#b45309',
    tertiary: '#f97316',
    text: '#fffbeb',
    categories: ['Payroll', 'Process', 'Risk'],
  },
  risk: {
    key: 'risk',
    label: 'Risk / Security',
    short: 'RISK',
    primary: '#dc2626',
    secondary: '#991b1b',
    tertiary: '#f43f5e',
    text: '#fff1f2',
    categories: ['Audit', 'Revoke', 'Critical'],
  },
});

export const PROJECT_KEYS = Object.freeze(Object.keys(PROJECT_META));

export function getProject(key) {
  return PROJECT_META[key] || PROJECT_META.ops;
}
